import React from 'react';
import { renderRoutesFromArray } from './renderRoutesFromArray';

const OnboardIntroduction = React.lazy(
  () => import('../screens/main/onboarding/onboard-introduction')
);
const OnboardFirstDuel = React.lazy(() => import('../screens/main/onboarding/onboard-first-duel'));
const OnboardKeepLearning = React.lazy(
  () => import('../screens/main/onboarding/onboard-keep-learning')
);
const OnboardFinal = React.lazy(() => import('../screens/main/onboarding/onboard-final'));
const OnboardPostDoi = React.lazy(() => import('../screens/main/onboarding/onboard-post-doi'));

const routeDefinitions = [
  {
    path: '/onboard-welcome',
    element: <OnboardIntroduction />,
  },
  {
    path: '/onboard-post-doi',
    element: <OnboardPostDoi />,
  },
  {
    path: '/onboard-first-duel',
    element: <OnboardFirstDuel />,
  },
  {
    path: '/onboard-keep-learning',
    element: <OnboardKeepLearning />,
  },
  {
    path: '/onboard-final',
    element: <OnboardFinal />,
  },
];

const onboardingRoutes = renderRoutesFromArray(routeDefinitions);
export default onboardingRoutes;
